/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, June 2022
 *
 *****************************************************************************/

import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
import loader from "../assets/loader/green_balls.json";

// styles
const style = {
  height: "5rem",
  width: "5rem",
  margin: "auto",
};

/**
 * Loading animation for account activation screen
 *
 * @returns loader
 */
const GreenLoader = () => {
  const anime = useRef(null);
  useEffect(() => {
    lottie.loadAnimation({
      container: anime.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: loader,
    });
    return () => lottie.stop();
  }, []);

  return <div style={style} ref={anime}></div>;
};

export default GreenLoader;
